export enum EditAction {
    NONE = 0,
    INSERT = 1,
    UPDATE = 2,
    DELETE = 3,
    RESTORE = 4,
    SELECTED = 5,
}